import state from './moduleCompetitionState';
import actions from './moduleCompetitionActions';
import mutations from './moduleCompetitionMutations';

export default {
  namespaced: true,
  isRegistered: false,
  state: state,
  actions: actions,
  mutations: mutations,
}